import { render, staticRenderFns } from "./FaBriefcasePrerenderred.vue?vue&type=template&id=7642c98a&"
import script from "./FaBriefcasePrerenderred.vue?vue&type=script&lang=js&"
export * from "./FaBriefcasePrerenderred.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports